import Swal from 'sweetalert2';
// import UsuarioService from './UsuarioService';
//const usuarioService = new UsuarioService();

const Front : string = process.env.REACT_APP_FRONT || '';
export default class AlertService{
  
    alertaAdvertencia(titulo: string, mensaj: string) {
        Swal.fire({
          //position: 'top-end',
          icon: 'warning',
          title: titulo,
          text: mensaj,
          showConfirmButton: false,          
          //timer: 10000
        })
      }
      alertaExito(titulo: string, mensaj: string) {
        return Swal.fire({
          //position: 'top-end',
          icon: 'success',
          title: titulo,
          text: mensaj,
          showConfirmButton: false,
          timer: 3000
        })
      }
      alertaAdvertenciaHtml(titulo: string, mensajeHtml: string) {
        Swal.fire({
          title: titulo,
          icon: 'warning',
          showConfirmButton: false,
          html: mensajeHtml
        });
      }
      alertaExitoHtml(titulo: string, mensajeHtml: string) {
        Swal.fire({
          title: titulo,
          icon: 'success',
          showConfirmButton: false,
          html: mensajeHtml,
          timer: 10000
        });
      }
      alertaAdvertenciaList(titulo: string, mensajeHtml: Array<string>) {
        const estructuraHtml = `
          <h2>Se presentaron las siguientes advertencias:</h2>
          <ul>
            ${mensajeHtml.map((error, index) => `<li key=${index}>${error}</li>`).join('')}
          </ul>
        `;
        Swal.fire({
          title: titulo,
          icon: 'warning',
          showConfirmButton: false,
          html: estructuraHtml
        });
      }  

      alertaAdvertenciaListSolicitudes(titulo: string, mensajeHtml: Array<string>) {
        const estructuraHtml = `
          <h2>Las siguientes solicitudes no pudieron ser aprobadas:</h2>
          <ul>
            ${mensajeHtml.map((error, index) => `<li key=${index}>${error}</li>`).join('')}
          </ul>
        `;
        Swal.fire({
          title: titulo,
          icon: 'warning',
          html: estructuraHtml,
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false, // Evita que se cierre al hacer clic afuera
          preConfirm: () => {
            window.location.reload(); // Recarga la página al hacer clic en el botón
        }
        });
      }  

      showLoading(titulo:string) {
        Swal.fire({
          title: titulo,
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton:false,
          showCancelButton: false,
          preConfirm: () => { },
          showLoaderOnConfirm: true,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }
      hideLoading(){
        Swal.close();
      }
      

    //   alertaEliminarUsuario(titulo: string,mensaje: string, idUser: number, token: any){
        
    //     Swal.fire({
    //       title: titulo,
    //       text: mensaje,
    //       icon:'warning',
    //       showCancelButton: true,
    //       confirmButtonText:'Si, eliminar',
    //       cancelButtonText:'No'
    //     }).then(async (result)=>{
    //       if(result.isConfirmed){
    //         this.showLoading("Eliminando...");
    //         const respuesta = await usuarioService.ElminarUsuarioById(token,idUser);
    //         this.hideLoading();
    //         //console.log(respuesta)
    //         if(respuesta.strEstado == 'S') {
    //             this.alertaExito("Exito","El usuario ha sido eliminado");
    //             setTimeout(() => {
    //                 window.location.reload();
    //             }, 3000);
                
    //         }else{
    //             this.alertaAdvertencia("Error",respuesta.strMensaje);
    //         }
    //       }
    //     })

    //   }
}